import React from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import moment from "moment"
import "./index.scss"

const Notification = ({ data = 0, next, hasMore, loader }) => {
  return (
    <>
      <ul
        id="notification-list"
        style={{ maxHeight: "400px", overflowY: "auto" }}
        className="notification-list"
      >
        <InfiniteScroll
          dataLength={data.length}
          next={next}
          hasMore={hasMore}
          loader={loader}
          scrollableTarget={"notification-list"}
        >
          {data ? (
            data.map((notif, i) => (
              <li key={i} className="notification-item">
                <p
                  dangerouslySetInnerHTML={{
                    __html: notif.description,
                  }}
                />
                <span className="timestamp">
                  {moment(notif.timestamp).fromNow(true)}
                </span>
              </li>
            ))
          ) : (
            <p className="is-centered p-md">No notifications found.</p>
          )}
        </InfiniteScroll>
      </ul>
      <div className="notification-footer">
        <button className="button">Mark all as read</button>
        <button className="button">View All</button>
      </div>
    </>
  )
}

export default Notification
